import MemberBenefits from './component';

export default MemberBenefits;



// WEBPACK FOOTER //
// ./app/src/components/MemberBenefits/index.js